import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import ZSearch from '../../Common/ZSearch';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { cloneArray, isDefined, sortReactTable } from '../../../utils';

class SelectTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: [],
            flag: false,
            searchTeamQuery: undefined,
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.selectOptions = this.selectOptions.bind(this);
        this.getOptionStyle = this.getOptionStyle.bind(this);

        this.onSearchTeam = this.onSearchTeam.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                onClose,
                closeOnClickOutside
            } = this.props;

        if (closeOnClickOutside) {
            return;
        }

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                onClose(this.state.selectedOptions);
            }
        }
    }

    onSearchTeam({ target }) {
        this.setState({ searchTeamQuery: target.value });
    }

    selectOptions(selectedId, selectedName, selectedDomainId) {
        const
            {
                selectMultiple,
                setSelectOptions
            } = this.props;
        const selectedOption = { id: selectedId, value: selectedName, domainId: selectedDomainId }

        //deselecting
        if (this.state.selectedOptions.some(o => o.id === selectedId)) {
            this.state.selectedOptions = this.state.selectedOptions.filter(o => o.id !== selectedId);
        }
        else {
            if (selectMultiple) {
                this.state.selectedOptions.push(selectedOption);
            }
            else {
                this.state.selectedOptions[0] = selectedOption;
            }
        }
        if (setSelectOptions) {
            setSelectOptions(this.state.selectedOptions);
        }
        this.setState({ flag: !this.state.flag });
    }

    getOptionStyle(optionId) {
        if (this.state.selectedOptions.some(o => o.id === optionId)) {
            const style =
            {
                border: '1px solid #C0EAED',
                boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px'
            }
            return style;
        }
    }

    render() {
        const
            {
                title,
                options,
                searchPlaceHolder
            } = this.props;

        let result = {};
        result.columns = [
            {
                Header: 'a',
                accessor: 'nameIcon'
            },
        ];

        const loading = !(options && Array.isArray(options));
        if (loading === true) {
            return (<ReactTable className="SelectTable"
                columns={result.columns}
                defaultPageSize={10}
                loading={loading}
                className="-striped -highlight"
            />);
        }

        result.data = cloneArray(options);

        if (isDefined(this.state.searchTeamQuery) && this.state.searchTeamQuery != '') {
            result.data = result.data.filter(a => a.name.toLowerCase().includes(this.state.searchTeamQuery.toLowerCase()));
        }

        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (isDefined(row.name)) {
                    let avatarBackground = 'linear-gradient(91.89deg, #98DDE1 -6.8%, #C0EAED 100.34%)';
                    let selectedIcon;
                    if (this.state.selectedOptions.some(o => o.id === row.id)) {
                        avatarBackground = 'linear-gradient(91.89deg, #935AD8 -6.8%, #AE83E2 100.34%)';
                        selectedIcon = <CheckCircleIcon style={{ color: '#FF9538', float: 'right' }} />;
                    }
                    const firstLetter = row.name.charAt(0).toUpperCase();

                    row.nameIcon = <div style={{ textAlign: 'start' }}>
                        <div style={{
                            background: avatarBackground,
                            borderRadius: '4px',
                            display: 'inline-block',
                            width: '32px',
                            color: 'white',
                            marginRight: '10px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            fontSize: '20px',
                            padding: '3px',

                        }}>
                            {firstLetter}
                        </div>

                        {row.name}{selectedIcon}
                    </div>;
                }
            });
        }

        const teamsResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={result.data.length}
            showPagination={false}
            loading={loading}
            className="-striped -highlight SelectTable"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {
                    return {
                        onClick: () => this.selectOptions(rowInfo.original.id, rowInfo.original.name, rowInfo.original.domainId),
                        style: this.getOptionStyle(rowInfo.original.id)
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        return <div ref={this.wrapperRef}>
            <div>
                <div className="select-pop-up-title" style={{ marginBottom: '10px' }}>{title}</div>
                <div style={{ marginBottom: '10px' }}>
                    <ZSearch placeHolder={searchPlaceHolder} searchValue={this.state.searchTeamQuery} onChange={this.onSearchTeam} />
                </div>
            </div>
            <div>
                {teamsResultTable}
            </div>
        </div>;
    };
}

const select = state => ({});
export default connect(select)(SelectTable);

